import { render, staticRenderFns } from "./infoStatistic.vue?vue&type=template&id=ce27c480&scoped=true&"
import script from "./infoStatistic.vue?vue&type=script&lang=js&"
export * from "./infoStatistic.vue?vue&type=script&lang=js&"
import style0 from "./infoStatistic.vue?vue&type=style&index=0&id=ce27c480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce27c480",
  null
  
)

export default component.exports